export async function getAccount() {
  return await this.$adminRepositories.sikulix.getAccount();
}

export async function update(_, payload) {
  return await this.$adminRepositories.sikulix.update(payload);
}
